import script from "./AdminTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminTable.vue?vue&type=script&setup=true&lang=ts"

import "./AdminTable.vue?vue&type=style&index=0&id=24616589&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24616589"]])

export default __exports__